import { render, staticRenderFns } from "./jxsdownload.vue?vue&type=template&id=80f017fa"
import script from "./jxsdownload.vue?vue&type=script&lang=js"
export * from "./jxsdownload.vue?vue&type=script&lang=js"
import style0 from "./jxsdownload.vue?vue&type=style&index=0&id=80f017fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports